import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useDeleteEventVenue = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      const response = await apiFetch(`api/event/venues/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
    },
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["event-venues"] }),
  });
};
